import React, { Component } from 'react'
import Layout from './Layout';
import { Table, Button, Modal, Input, Switch, Popconfirm, Breadcrumb, message } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { adminRoutes } from '../helpers/adminRoutes';
import { getCategories, addCategory, deleteCategory } from '../redux/actions/category';

class CategoryList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            modalOpen: false,
            editId: null,
            name: '',
            status: true,
            saving: false,
        }
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        let { dispatch } = this.props;
        dispatch(getCategories());
    }

    openAdd = () => {
        this.setState({ modalOpen: true, editId: null, name: '', status: true });
    }

    openEdit = (category) => {
        this.setState({ modalOpen: true, editId: category._id, name: category.name, status: category.status });
    }

    closeModal = () => {
        this.setState({ modalOpen: false });
    }

    save = () => {
        let { dispatch } = this.props;
        let { editId, name, status } = this.state;

        if (!name || !name.trim()) {
            message.error('Name is required.');
            return;
        }

        this.setState({ saving: true });
        dispatch(addCategory({ id: editId, name, status }, !!editId)).then(() => {
            this.setState({ saving: false, modalOpen: false });
            this.load();
        }).catch(() => {
            this.setState({ saving: false });
            message.error('Something went wrong saving this category.');
        })
    }

    handleDelete = (id) => {
        let { dispatch } = this.props;
        dispatch(deleteCategory(id)).then(() => {
            this.load();
        })
    }

    render() {
        let { data } = this.props;
        let categories = (data && data.data && data.data.data) || [];
        let { modalOpen, editId, name, status, saving } = this.state;

        const columns = [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                render: (val) => val ? 'Active' : 'Inactive',
            },
            {
                title: '',
                key: 'actions',
                render: (_, category) => (
                    <div className="d-flex">
                        <Button onClick={() => this.openEdit(category)}>Edit</Button>
                        <Popconfirm
                            title="Are you sure you want to delete this category?"
                            onConfirm={() => this.handleDelete(category._id)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button style={{ marginLeft: 8 }}>Delete</Button>
                        </Popconfirm>
                    </div>
                ),
            },
        ];

        return (
            <Layout>
                <div className="content-box supplies-page">
                    <div className="bredcrumb-div">
                        <Breadcrumb separator="-">
                            <Breadcrumb.Item><Link to={adminRoutes.SUPPLYLIST}>Supplies</Link></Breadcrumb.Item>
                            <Breadcrumb.Item><Link to={adminRoutes.CATEGORYLIST}>Categories</Link></Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div className="page-title d-flex">
                        <h2>Categories</h2>
                        <Button onClick={this.openAdd} type="primary" className="primary-btn" style={{ minWidth: 170 }}> ADD CATEGORY </Button>
                    </div>
                    <div className="page-content">
                        <Table
                            rowKey="_id"
                            dataSource={categories}
                            columns={columns}
                            pagination={false}
                        />
                    </div>
                </div>

                {/* No onOk/footer — App.css hides the default modal footer app-wide
                    (see .ant-modal-body + .ant-modal-footer), so the submit button
                    lives in the body instead, matching AddPattern.jsx's modals. */}
                <Modal
                    title={editId ? 'Edit Category' : 'Add Category'}
                    visible={modalOpen}
                    onCancel={this.closeModal}
                    footer={null}
                    wrapClassName="supplies-page"
                >
                    <label>Name</label>
                    <Input
                        value={name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                        placeholder="Category name"
                    />
                    <div style={{ marginTop: 16 }}>
                        <label style={{ marginRight: 8 }}>Active</label>
                        <Switch checked={status} onChange={(val) => this.setState({ status: val })} />
                    </div>
                    <div className="popup-btn" style={{ marginTop: 20 }}>
                        <button onClick={this.save} disabled={saving} className="ant-btn OrangeButton"><span>Save</span></button>
                    </div>
                </Modal>
            </Layout>
        )
    }
}

const mapStateToProps = ((state) => {
    let { loading, data, error } = state.getCategories
    return {
        loading,
        data,
        error,
    }
})

export default connect(mapStateToProps)(CategoryList);
